// extracted by mini-css-extract-plugin
export default {"FlightEntryListLoading":"FlightEntryList_FlightEntryListLoading__MGY5Y"};